import { GET_GOVERNORATES_REQUEST, PULL_GOVERNORATES_REQUEST } from '../types/governorates'

export function getGovernorates(payload) {
  return {
    type: GET_GOVERNORATES_REQUEST,
    payload,
  }
}

export function pullGovernorates(payload) {
  return {
    type: PULL_GOVERNORATES_REQUEST,
    payload,
  }
}

